import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, MenuItem } from '@material-ui/core';
import { Flex, IconButton, Select } from '@knockrentals/knock-shared-web-v2';
import MaxIncome from './MaxIncome';
import { makeCss } from '../../../../../../../knock-design-system';
import { FIELD_LABELS, MAXIMUM_INCOME, OCCUPANTS } from '../constants';

export const DELETE_ROW_LABEL = 'delete row';

const useCss = makeCss({
  field: {
    flex: 'none',
    width: '200px',
    '& .MuiFormControl-root': {
      width: '100%',
    },
  },
});

const EligibleQualification = ({
  clearValidationErrorMessage,
  deleteEligibleQualification,
  errorMessages = {},
  maximumIncome,
  occupants,
  personOptions,
  updateEligibleQualification,
}) => {
  const css = useCss();
  const handleOccupantsOnChange = (value) => {
    updateEligibleQualification({ [OCCUPANTS]: value });
  };

  const handleOccupantsOnFocus = () => {
    if (errorMessages[OCCUPANTS]) {
      clearValidationErrorMessage(OCCUPANTS);
    }
  };

  const handleMaxIncomeOnChange = (value) => {
    updateEligibleQualification({ [MAXIMUM_INCOME]: value });
  };

  const handleClearMaxIncomeError = () => {
    clearValidationErrorMessage(MAXIMUM_INCOME);
  };

  return (
    <Flex alignItems="flex-start" gap={16}>
      <div css={css.field}>
        <Select
          aria-label={FIELD_LABELS[OCCUPANTS]}
          error={Boolean(errorMessages[OCCUPANTS])}
          fullWidth
          onChange={handleOccupantsOnChange}
          onFocus={handleOccupantsOnFocus}
          optionRenderer={(option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={Boolean(option.disabled)}
            >
              {option.label}
            </MenuItem>
          )}
          options={personOptions}
          value={occupants || ''}
          variant="outlined"
        />
        {errorMessages[OCCUPANTS] && (
          <FormHelperText error>{errorMessages[OCCUPANTS]}</FormHelperText>
        )}
      </div>

      <div css={css.field}>
        <MaxIncome
          clearValidationErrorMessage={handleClearMaxIncomeError}
          errorMessage={errorMessages[MAXIMUM_INCOME]}
          maxIncome={maximumIncome || ''}
          maxIncomeOnChange={handleMaxIncomeOnChange}
        />
      </div>

      <IconButton
        aria-label={DELETE_ROW_LABEL}
        color="destructive"
        iconName="trash-bin"
        onClick={deleteEligibleQualification}
      />
    </Flex>
  );
};

EligibleQualification.propTypes = {
  clearValidationErrorMessage: PropTypes.func,
  deleteEligibleQualification: PropTypes.func,
  errorMessages: PropTypes.shape({
    [MAXIMUM_INCOME]: PropTypes.string,
    [OCCUPANTS]: PropTypes.string,
  }),
  maximumIncome: PropTypes.string,
  occupants: PropTypes.string,
  personOptions: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  updateEligibleQualification: PropTypes.func,
};

export default EligibleQualification;
